var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarker = function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 36,
    viewBox: "0 0 33 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "marker_red-a",
    width: "180%",
    height: "700%",
    x: "-40%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 2.376
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.662,
    cy: 27.324,
    fill: "#212529",
    filter: "url(#marker_red-a)",
    rx: 8.91,
    ry: 1.188
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.512,
    height: 28.512
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M14.2560002,2.37600003 C19.9584003,2.37600003 23.7600003,6.4458617 23.7600003,12.5506542 C23.7600003,16.3161775 21.0480824,20.6623578 15.6242465,25.5891953 C14.8482597,26.2940767 13.6637456,26.2940767 12.8877588,25.5891954 L12.8877588,25.5891954 L12.5221518,25.2541768 C7.34205066,20.4651055 4.75200006,16.230598 4.75200006,12.5506542 C4.75200006,6.4458617 8.55360011,2.37600003 14.2560002,2.37600003 Z M14.2560002,8.31600011 C12.2876573,8.31600011 10.6920001,9.91165728 10.6920001,11.8800002 C10.6920001,13.848343 12.2876573,15.4440002 14.2560002,15.4440002 C16.2243431,15.4440002 17.8200002,13.848343 17.8200002,11.8800002 C17.8200002,9.91165728 16.2243431,8.31600011 14.2560002,8.31600011 Z"
  }))));
};
export default SvgMarker;